module.exports = __webpack_public_path__ + "img/8.09dbf255.png";